import { calculateTo } from "@hooks/useNavigate/useNavigate";
import { FunctionComponent } from "react";
import { NavLinkProps, To, useLocation } from "react-router";
// eslint-disable-next-line no-restricted-imports
import { NavLink as NavLinkInternal } from "react-router";

const NavLink: FunctionComponent<NavLinkProps> = (props) => {
  const { to: toInternal, children, ...rest } = props;

  const { search } = useLocation();
  const calculatedTo = calculateTo(toInternal, search, rest) as { to: To };

  return (
    <NavLinkInternal {...rest} to={calculatedTo.to}>
      {children}
    </NavLinkInternal>
  );
};

export { NavLink };
